import { gql, useMutation } from '@apollo/client';

import { TENANT_REGISTRATION_REQUEST_FIELDS, TenantRegistrationRequest } from './useTenantRegistrationRequestsQuery';

const APPROVE_TENANT_REGISTRATION_REQUEST = gql`
  ${TENANT_REGISTRATION_REQUEST_FIELDS}
  mutation ApproveTenantRegistrationRequest($id: String!) {
    approveTenantRegistrationRequest(id: $id) {
      ...TenantRegistrationRequestFields
    }
  }
`;

const REJECT_TENANT_REGISTRATION_REQUEST = gql`
  ${TENANT_REGISTRATION_REQUEST_FIELDS}
  mutation RejectTenantRegistrationRequest($id: String!, $reason: String) {
    rejectTenantRegistrationRequest(id: $id, reason: $reason) {
      ...TenantRegistrationRequestFields
    }
  }
`;

const UPDATE_TENANT_REGISTRATION_REQUEST = gql`
  ${TENANT_REGISTRATION_REQUEST_FIELDS}
  mutation UpdateTenantRegistrationRequest(
    $id: String!
    $companyName: String!
    $website: String
    $phone: String!
    $street: String!
    $zip: String!
    $city: String!
    $contactFirstName: String!
    $contactLastName: String!
    $contactEmail: String!
  ) {
    updateTenantRegistrationRequest(
      id: $id
      companyName: $companyName
      website: $website
      phone: $phone
      street: $street
      zip: $zip
      city: $city
      contactFirstName: $contactFirstName
      contactLastName: $contactLastName
      contactEmail: $contactEmail
    ) {
      ...TenantRegistrationRequestFields
    }
  }
`;

const RESET_TENANT_REGISTRATION_REQUEST = gql`
  ${TENANT_REGISTRATION_REQUEST_FIELDS}
  mutation ResetTenantRegistrationRequest($id: String!) {
    resetTenantRegistrationRequest(id: $id) {
      ...TenantRegistrationRequestFields
    }
  }
`;

export interface ApproveTenantRegistrationRequestResult {
  approveTenantRegistrationRequest: TenantRegistrationRequest;
}

export interface RejectTenantRegistrationRequestResult {
  rejectTenantRegistrationRequest: TenantRegistrationRequest;
}

export interface UpdateTenantRegistrationRequestResult {
  updateTenantRegistrationRequest: TenantRegistrationRequest;
}

export interface UpdateTenantRegistrationRequestVariables {
  id: string;
  companyName: string;
  website?: string | null;
  phone: string;
  street: string;
  zip: string;
  city: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
}

export interface ResetTenantRegistrationRequestResult {
  resetTenantRegistrationRequest: TenantRegistrationRequest;
}

export function useApproveTenantRegistrationRequestMutation() {
  return useMutation<ApproveTenantRegistrationRequestResult, { id: string }>(APPROVE_TENANT_REGISTRATION_REQUEST, {
    refetchQueries: ['GetTenantRegistrationRequests', 'GetPendingTenantRegistrationCount', 'GetUser'],
  });
}

export function useRejectTenantRegistrationRequestMutation() {
  return useMutation<RejectTenantRegistrationRequestResult, { id: string; reason?: string }>(
    REJECT_TENANT_REGISTRATION_REQUEST,
    {
      refetchQueries: ['GetTenantRegistrationRequests', 'GetPendingTenantRegistrationCount'],
    }
  );
}

export function useUpdateTenantRegistrationRequestMutation() {
  return useMutation<UpdateTenantRegistrationRequestResult, UpdateTenantRegistrationRequestVariables>(
    UPDATE_TENANT_REGISTRATION_REQUEST,
    {
      refetchQueries: ['GetTenantRegistrationRequests'],
    }
  );
}

export function useResetTenantRegistrationRequestMutation() {
  return useMutation<ResetTenantRegistrationRequestResult, { id: string }>(RESET_TENANT_REGISTRATION_REQUEST, {
    refetchQueries: ['GetTenantRegistrationRequests'],
  });
}
